// extracted by mini-css-extract-plugin
module.exports = {"price":"CQ-z","onSale":"DQ-z"};